import store from '../store';
import Stats from '../views/stats/Index.vue';
import { checkauth } from '../Helper';

export default [
	{
		path: '/stats',
		name: 'stats',
		component: Stats,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				// console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
];
